import React from "react";

export default function BackupImageSettingsFooter({
  saving,
  isSaveDisabled,
  onCancel,
  onSave,
}) {
  return (
    <div className="backup-image-settings-footer">
      <button type="button" className="footer-button cancel" onClick={onCancel}>
        CANCEL
      </button>
      <button
        type="button"
        className="footer-button save"
        onClick={onSave}
        disabled={isSaveDisabled}
      >
        {saving ? "SAVING..." : "SAVE SETTING"}
      </button>
    </div>
  );
}
